document.addEventListener("DOMContentLoaded", function () {
  single_article_slider();
});

[
  "shopify:section:load",
  "shopify:section:unload",
  "shopify:section:select",
  "shopify:section:deselect",
  "shopify:block:select",
  "shopify:block:deselect"
].forEach(function(eventName) {
  document.addEventListener(eventName, function () {
    single_article_slider();
  });
});

function single_article_slider() {
  const single_article_slider = document.querySelectorAll('.nbp-single-slider .swiper');

    single_article_slider.forEach(function (swiperContainer) {
      var swiperId = swiperContainer.id;
      console.log('#' + swiperId)
        var sectionId = swiperId.split('wiper-')[1];

        var prevButtonId = 'prev-' + sectionId;
        var nextButtonId = 'next-' + sectionId;

        var slider = new Swiper('#' + swiperId, {
            autoHeight: true,
            calculateHeight: false,
            slidesPerView: 1,
            watchOverflow: false,
            slideToClickedSlide: false,
            spaceBetween: 16,
            loop: true,
            speed: 1000,
            navigation: {
                nextEl: '#' + nextButtonId,
                prevEl: '#' + prevButtonId,
            }
        });
    });
  
  // new way 
  // const single_article_slider = document.querySelectorAll('.nbp-single-slider .swiper');
  
  // single_article_slider.forEach(function (swiperContainer) { 
  //   var swiperId = swiperContainer.id;
  //   const swiperEl = document.querySelector('#' + swiperId);
  //   console.log('NBP-SINGLE-SLIDER', swiperEl );
    
  //   const swiperParams = {
  //     slidesPerView: 1,
  //     spaceBetween: 20,
  //     loop: true,
  //     autoHeight: true,
  //     calculateHeight: false,
  //     navigation: {
  //       nextEl: '.slider-button-next',
  //       prevEl: '.slider-button-prev',
  //     },
  //     breakpoints: {
  //       1500: { spaceBetween: 35, slidesPerView: 3 },
  //       1200: { spaceBetween: 28, slidesPerView: 3 },
  //       990: { spaceBetween: 24, slidesPerView: 2.5 },
  //       750: { spaceBetween: 24, slidesPerView: 1.8 },
  //       550: { spaceBetween: 24, slidesPerView: 1.5 },
  //       430: { spaceBetween: 20, slidesPerView: 1.2 },
  //       380: { spaceBetween: 16, slidesPerView: 1.2 },
  //       360: { spaceBetween: 16, slidesPerView: 1.1 },
  //     },
  //   };
    
  //   Object.assign(swiperEl, swiperParams);
  //   swiperEl.initialize();
  // })

}